import React, { useState } from 'react';
import ImagePickerModal from './ImagePickerModal';

const ImagePickerField = ({ 
  label, 
  value, 
  onSelect, 
  multiple = false, 
  description 
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Helper to get preview
  const getPreview = () => {
    if (multiple) {
      const images = Array.isArray(value) ? value : [];
      if (images.length > 0) {
        return (
          <div className="flex flex-wrap gap-2 mt-4">
            {images.map((img, idx) => (
              <div key={idx} className="relative w-20 h-20 rounded-xl overflow-hidden group shadow-sm">
                <img src={img} alt="Preview" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                   <button 
                    type="button"
                    onClick={() => onSelect(images.filter((_, i) => i !== idx))}
                    className="bg-white p-1 rounded-full text-red-500 shadow-sm"
                   >
                     <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                     </svg>
                   </button>
                </div>
              </div>
            ))}
            <button
              type="button"
              onClick={() => setIsModalOpen(true)}
              className="w-20 h-20 rounded-xl border-2 border-dashed border-gray-200 flex flex-col items-center justify-center text-black hover:border-black hover:bg-gray-50 transition-all font-bold"
            >
              <svg className="w-6 h-6 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
              </svg>
              <span className="text-[8px] font-bold uppercase">Još</span>
            </button>
          </div>
        );
      }
    }

    if (value) {
      return (
        <div className="mt-4 relative w-40 h-24 rounded-2xl overflow-hidden group shadow-md border border-gray-100">
          <img src={value} alt="Preview" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-3">
             <button 
              type="button"
              onClick={() => setIsModalOpen(true)}
              className="bg-white px-3 py-1.5 rounded-lg text-[9px] font-bold uppercase text-black shadow-lg"
             >
               Promijeni
             </button>
             <button 
              type="button"
              onClick={() => onSelect('')}
              className="bg-red-500 px-3 py-1.5 rounded-lg text-[9px] font-bold uppercase text-white shadow-lg"
             >
               Ukloni
             </button>
          </div>
        </div>
      );
    }

    return (
      <button
        type="button"
        onClick={() => setIsModalOpen(true)}
        className="mt-4 w-full h-24 rounded-2xl border-2 border-dashed border-gray-200 flex flex-col items-center justify-center text-black hover:border-black hover:bg-gray-50/50 transition-all group"
      >
        <div className="bg-gray-100 p-2 rounded-full mb-2 group-hover:bg-black group-hover:text-white transition-colors">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        </div>
        <span className="text-[10px] font-black uppercase tracking-widest">Odaberi fotografiju</span>
      </button>
    );
  };

  return (
    <div className="space-y-2">
      <div className="flex flex-col">
        <label className="text-[10px] font-black text-black uppercase tracking-widest">{label}</label>
        {description && <p className="text-[9px] text-black italic mt-0.5">{description}</p>}
      </div>
      
      {getPreview()}

      <ImagePickerModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSelect={onSelect}
        currentValue={value}
        multiple={multiple}
        title={label}
      />
    </div>
  );
};

export default ImagePickerField;
